import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CasinoState {
  isOpen: boolean;
  gameUrl?: string | null;
}

const initialState: CasinoState = {
  isOpen: false,
  gameUrl: null,
};

export const casinoSlice = createSlice({
  name: 'casino',
  initialState,
  reducers: {
    closeGame: (state) => {
      state.isOpen = false;
      state.gameUrl = null;
    },
    launchGame: (state, action: PayloadAction<string>) => {
      state.isOpen = true;
      state.gameUrl = action.payload;
    },
  },
});

export const { closeGame, launchGame } = casinoSlice.actions;
